import { useEffect, useState, useMemo, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { AgGridContextMenu } from "@components/ag_grid/AgGridContextMenu";

const PtoReview = ({ allWorkers, ptoRequests }) => {
  const [workers, setWorkers] = useState([]);
  const [requests, setRequests] = useState([]);

  // Context menu hook
  const { handleCellContextMenu, ContextMenuComponent } = AgGridContextMenu({});
  // Prevent default browser context menu
  const handleContextMenu = useCallback((event) => {
    event.preventDefault();
  }, []);

  useEffect(() => {
    setWorkers(allWorkers);
    setRequests(ptoRequests ? ptoRequests : []);
  }, [ptoRequests, allWorkers]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(-2);
    return `${month}/${day}/${year}`;
  };

  // Optimize worker lookups by creating indexed maps - O(1) instead of O(n)
  const workerMaps = useMemo(() => {
    const nameMap = new Map();
    const contractorIdMap = new Map();

    workers.forEach((worker) => {
      nameMap.set(worker.id, worker.name || "Unknown");
      contractorIdMap.set(worker.id, worker.contractor_id || "Unknown");
    });

    return { nameMap, contractorIdMap };
  }, [workers]);

  const columnDefs = useMemo(() => {
    const getWorkerNameById = (workerId) => {
      return workerMaps.nameMap.get(workerId) || "Unknown";
    };

    const getContIdByWorkerId = (workerId) => {
      return workerMaps.contractorIdMap.get(workerId) || "Unknown";
    };

    return [
      {
        headerName: "ID",
        field: "worker_id",
        width: 100,
        filter: true,
        valueGetter: (params) => getContIdByWorkerId(params.data.worker_id),
      },
      {
        headerName: "Name",
        field: "worker_id",
        width: 200,
        filter: true,
        valueGetter: (params) => getWorkerNameById(params.data.worker_id),
      },
      {
        headerName: "Submit Date",
        field: "request_date",
        width: 130,
        filter: true,
        valueFormatter: (params) => formatDate(params.value),
      },
      {
        headerName: "Off Date(s)",
        field: "start_date",
        width: 180,
        filter: true,
        valueGetter: (params) => {
          const { start_date, end_date } = params.data;
          return start_date === end_date
            ? formatDate(start_date)
            : `${formatDate(start_date)} - ${formatDate(end_date)}`;
        },
      },
      {
        headerName: "Hours Total",
        field: "hours_requested",
        width: 120,
        filter: true,
      },
      {
        headerName: "Request Status",
        field: "status",
        width: 150,
        filter: true,
        valueFormatter: (params) => params.value || "unknown",
      },
    ];
  }, [workerMaps]);

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      resizable: true,
    }),
    []
  );

  return (
    <div className="tw-bg-white tw-rounded-lg tw-border tw-border-gray-200 tw-p-4">
      {/* <h1 className="tw-text-xl tw-font-semibold tw-mb-4">PTO Requests</h1> */}
      <div
        className="ag-theme-balham tw-h-[73dvh] tw-w-full"
        onContextMenu={handleContextMenu}
      >
        <AgGridReact
          // className="ag-theme-balham"
          // domLayout="autoHeight"
          rowData={requests}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onCellContextMenu={handleCellContextMenu}
          // pagination={true}
          // paginationPageSize={15}
          animateRows={true}
        />
        {ContextMenuComponent}
      </div>
    </div>
  );
};

export default PtoReview;
